const state = {
  login: {
    token: false,
    user_id: null,
    name: 'ゲスト',
    is_admin: false,
    expire: 0,
  },
}

const getters = {
  getLogin: (state) => state.login,
  getLoginToken: (state) => state.login.token,
  getLoginUserID: (state) => state.login.user_id,
  getLoginUserName: (state) => state.login.name,
  getLoginIsAdmin: (state) => state.login.is_admin,
}

const mutations = {
  saveLoginName: (state, name) => {
    state.login.name = name
  },
  saveLoginInfo: (state, login) => {
    state.login.token = login.token
    state.login.user_id = login.user_id
    state.login.name = login.name
    state.login.is_admin = login.is_admin
    state.login.expire = Math.floor(1000 * login.expire)
  },
}

const actions = {
  setLoginName({ commit }, name) {
    commit('saveLoginName', name)
  },
  setLoginInfo({ commit }, login) {
    commit('saveLoginInfo', login)
  },
  unsetLoginInfo({ commit }) {
    commit('saveLoginInfo', {
      token: false,
      user_id: null,
      name: 'ゲスト',
      is_admin: false,
      expire: 0,
    })
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
